export interface IPartNameProps {
  name: string;
  received?: boolean;
  orderObjectId?: string;
  isPlanning?: boolean;
  marketplace?: string;
}

function PartName({ name, received, orderObjectId, isPlanning, marketplace }: IPartNameProps) {
  let nameToDisplay = name;
  switch (name) {
    case 'vtx':
      nameToDisplay = 'VTX: ';
      break;
    case 'Flight controller':
      nameToDisplay = 'FC: ';
      break;
    case 'vtxAntenna':
      nameToDisplay = 'VTX antenna: ';
      break;
    case 'vtxAntennaConnector':
      nameToDisplay = 'VTX pigtail: ';
      break;
    case 'FC Stack':
      nameToDisplay = 'Stack: ';
      break;
    default:
      nameToDisplay = `${name?.[0].toUpperCase()}${name?.slice(1)}: `;
  }
  if (!received && orderObjectId) {
    if (isPlanning) {
      return `${nameToDisplay}`;
    }
    if (marketplace === 'aliexpress') {
      return <a target="_blank" rel="noopener noreferrer" href={`https://www.aliexpress.com/p/tracking/index.html?spm=a2g0o.order_detail.order_detail_item.2.333df19cuBvVwt&_addShare=no&_login=yes&tradeOrderId=${orderObjectId}`}>{nameToDisplay}</a>;
    }
    return nameToDisplay
  }
  return nameToDisplay;
}

export default PartName;
